module.exports = __webpack_public_path__ + "img/googleG.b7727941.svg";